
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.125 4h.594l.281.5.938 1.656c1.545.156 3.628.829 5.438 3.25 2.055 2.749 3.625 7.468 3.625 15.594v1h-9.656c-.989.617-2.104 1-3.344 1s-2.355-.375-3.344-1H3.001v-1c0-9.134 1.977-14.423 4.969-17.438s6.852-3.563 10.156-3.563zm-.562 2.063c-2.914.059-5.867.568-8.188 2.906C7.009 11.353 5.215 15.864 5.062 24h5.406a11.28 11.28 0 01-.344-.469C8.767 21.59 7.999 19.198 7.999 17c0-.783.212-1.515.625-2.063s.978-.894 1.563-1.125c1.169-.461 2.477-.521 3.719-.625s2.43-.242 3.125-.563.969-.581.969-1.625h2c0 1.66-.976 2.893-2.156 3.438s-2.492.644-3.75.75-2.45.221-3.156.5c-.353.139-.585.292-.719.469S10 16.556 10 17c0 1.711.643 3.824 1.75 5.406S14.337 25 16 25c1.665 0 3.144-1.014 4.25-2.594S22 18.722 22 17h2c0 2.207-.767 4.624-2.125 6.563-.102.146-.203.297-.313.438h5.375c-.136-7.17-1.553-11.261-3.156-13.406-1.684-2.253-3.521-2.594-4.531-2.594h-.594l-.281-.5zM13 17a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    